import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const CollectionManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Tahsilat Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Tahsilat yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default CollectionManagement;
